"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnknownRenderer = exports.UnknownControl = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("@jsonforms/react");
function UnknownControl(props) {
    // console.log({ schema: props.schema, path: props.path, schemaPath: props.schemaPath, props })
    return ((0, jsx_runtime_1.jsxs)("div", { style: { color: "red" }, children: ["No applicable renderer found for ", props.schema?.type, " type field \"", props.path, "\"."] }));
}
exports.UnknownControl = UnknownControl;
exports.UnknownRenderer = (0, react_1.withJsonFormsControlProps)(UnknownControl);
